/**
 * App shell — React Router routes for the seven prototype pages.
 * The iframe/postMessage bridge is replaced by React Router + SessionContext
 * (added in Phase 1 step 7). Routes are placeholders with visual structure
 * filled in across Phase 1; real APIs wire in Phase 4.
 */
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { SignIn } from './pages/SignIn';
import { Home } from './pages/Home';
import { IdeaScan } from './pages/IdeaScan';
import { Learning } from './pages/Learning';
import { Book } from './pages/Book';
import { Alerts } from './pages/Alerts';
import { Settings } from './pages/Settings';
import { NotFound } from './pages/NotFound';
import { GoalPage } from './pages/GoalPage';
import { Goodbye } from './pages/Goodbye';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { CookiePolicy } from './pages/CookiePolicy';

export function App() {
  return (
    <Routes>
      <Route path="/signin" element={<SignIn />} />
      <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path="/idea" element={<ProtectedRoute><IdeaScan /></ProtectedRoute>} />
      <Route path="/learning" element={<ProtectedRoute><Learning /></ProtectedRoute>} />
      <Route path="/book" element={<ProtectedRoute><Book /></ProtectedRoute>} />
      <Route path="/alerts" element={<ProtectedRoute><Alerts /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      {/* §12 conversion goal pages — first-time-only success views. */}
      <Route path="/welcome" element={<ProtectedRoute><GoalPage variant="welcome" /></ProtectedRoute>} />
      <Route path="/booking-confirmed" element={<ProtectedRoute><GoalPage variant="booking-confirmed" /></ProtectedRoute>} />
      {/* UK GDPR Art. 17 — public post-deletion landing (no auth; account is gone). */}
      <Route path="/goodbye" element={<Goodbye />} />
      {/* UK GDPR Art. 13 / PECR Reg. 6 — public legal pages (no auth; readable before sign-up). */}
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export { Navigate };